import { Box, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store/appHooks";

const DashboardCounts = () => {
  const { dashboardReducer } = useAppSelector((state) => state);
  const { dashboardStats }: any = dashboardReducer;
  const navigate = useNavigate();

  return (
    <Grid container spacing={"2.5%"}>
      <Grid item md={3} lg={3} xl={3} sm={6} xs={6}>
        <OtherCountBoxes
          isProfit={
            dashboardStats?.total_bookings?.bookingPercentageStatus !==
            "downward"
          }
          label="Total Bookings"
          profitLossPercentage={
            dashboardStats?.total_bookings?.bookingPercentage
          }
          profitLossCount={dashboardStats?.total_bookings?.bookingDifference}
          count={dashboardStats?.total_bookings?.totalBookings}
          onClick={() => {}}
        />
      </Grid>
      <Grid item md={3} lg={3} xl={3} sm={6} xs={6}>
        <OtherCountBoxes
          isProfit={
            dashboardStats?.pending_requests?.bookingPercentageStatus !==
            "downward"
          }
          label="Pending Requests"
          profitLossPercentage={
            dashboardStats?.pending_requests?.pendingRequesPercentage
          }
          profitLossCount={
            dashboardStats?.pending_requests?.pendingRequesDifference
          }
          count={dashboardStats?.pending_requests?.pendingRequests}
          onClick={() => navigate("/rental?type=pending")}
        />
      </Grid>
      <Grid item md={3} lg={3} xl={3} sm={6} xs={6}>
        <OtherCountBoxes
          isProfit={
            dashboardStats?.cancelled_bookings
              ?.cancelledBookingPercentageStatus !== "downward"
          }
          label="Cancel"
          profitLossPercentage={
            dashboardStats?.cancelled_bookings?.cancelledBookingPercentage
          }
          profitLossCount={
            dashboardStats?.cancelled_bookings?.cancelledBookingDifference
          }
          count={dashboardStats?.cancelled_bookings?.cancelledBookings}
          onClick={() => navigate("/rental?type=cancelled")}
        />
      </Grid>
      <Grid item md={3} lg={3} xl={3} sm={6} xs={6}>
        <OtherCountBoxes
          isProfit={
            dashboardStats?.confirmed_requests?.listingPercentageStatus !==
            "downward"
          }
          label="Confirmed Requests"
          profitLossPercentage={
            dashboardStats?.confirmed_requests?.listingPercentage
          }
          profitLossCount={
            dashboardStats?.confirmed_requests?.listingDifference
          }
          count={dashboardStats?.confirmed_requests?.totalListings}
          onClick={() => navigate("/rental?type=confirmed")}
        />
      </Grid>
    </Grid>
  );
};

const ProfitLossBadge = ({ profit = true, value }: any) => {
  return (
    <Box
      sx={{
        // height: "32px",
        padding: "10px",
        background: "#FFF",
        borderRadius: "10px",
        display: "flex",
        gap: "10px",

        alignItems: "center",
        width: "fit-content",
      }}
    >
      <img
        src={
          profit
            ? "/assets/img/icons/profit_ar.svg"
            : "/assets/img/icons/loss_sr.svg"
        }
        alt=""
        height="16"
        width="16"
      />
      <Typography
        sx={{
          fontSize: "13px",
          lineHeight: "15px",
          fontWeight: 600,
          color: profit ? "#4EA643" : "#D21A00",
        }}
        component="div"
      >
        {value}%
      </Typography>
    </Box>
  );
};

const OtherCountBoxes = ({
  count = 0,
  label = "",
  isProfit,
  profitLossPercentage = 0,
  profitLossCount = 0,
  onClick,
}: {
  count: number;
  label: string;
  isProfit: boolean;
  profitLossPercentage: number;
  profitLossCount: number;
  onClick: any;
}) => {
  return (
    <Box
      sx={{
        padding: "15px",
        borderRadius: "10px",
        boxShadow: "0px 3px 6px 0px #25334B1A, 0px 10px 20px 0px #25334B1A",
        ":hover": {
          background: "#307AFF",
          "& p": {
            color: "#FFF !important",
          },
        },
        cursor: "pointer",
        height: "80%",
      }}
      onClick={onClick}
    >
      <Typography
        sx={{
          color: "#323232",
          lineHeight: "22px",
          fontSize: {
            md: "18px",
            lg: "18px",
            xl: "18px",
            sm: "14px",
            xs: "14px",
          },
          fontWeight: 600,
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          height: "2px",
          width: "100%",
          borderBottom: "1px dashed #DFDFDF",
          mt: "6px",
          mb: "15px",
          borderSpacing: "2px",
        }}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: "#323232",
            fontSize: "18px",
            fontWeight: 600,
            lineHeight: "22px",
          }}
        >
          {count}
        </Typography>
        <ProfitLossBadge profit={isProfit} value={profitLossPercentage} />
      </Box>

      <Typography
        sx={{
          fontSize: "13px",
          fontWeight: 400,
          lineHeight: "16px",
          mt: "8px",
          color: "#A2A2A2",
        }}
      >
        {profitLossCount}{" "}
        {isProfit ? `more than last month` : `less than last month`}
      </Typography>
    </Box>
  );
};
export default DashboardCounts;
